// import LeftArrowIcon from '.././icons/LeftArrowIcon.svg'
// import RightArrowIcon from '.././icons/RightArrowIcon.svg'
import styled from 'styled-components'
import utils from '../../utils/utils'
import {
 // , railItemWidth size, railItemLineHeight, centerModePadding 
  device, 
  
} from '../../constants/breakpoints'
/* --------------------------------------------- */
// Styled components of Rail component.
export const Title = styled.div`
  color: ${({ theme: { header } }) => header && header.text.primary};
`
/* --------------------------------------------- */

/* --------------------------------------------- */
export const ViewAll = styled.div`
  color: ${({ theme: { header } }) => header && header?.text?.secondary};

  @media (hover: hover) {
    &:hover {
      color: ${({ theme: { header } }) => header && header?.accent?.primary};
    }
  }
`;
/* --------------------------------------------- */

/* --------------------------------------------- */
export const LayoutContainer = styled.div`
  ${({ componentStyles, theme: { compositeStyle } }) => {
    return componentStyles.map((singleStyle) => {
      const { filter = {}, itemSize } = singleStyle
      const { displayOrientation: screenResolution = [] } = filter || {}
      return Object.keys(device).map((resolution) => {
        if (screenResolution[0] === 'landscape' && resolution.indexOf('mobile') !== -1) return ''
        if (screenResolution[0] === 'portrait' && resolution.indexOf('mobile') === -1) return ''

        return `
            @media ${device[resolution]} {
              padding: ${(resolution.indexOf('mobile') !== -1 && itemSize === 'fill_width') ? '0 0 15px 0' : '10px 0'}; 
              .slick-dots li button:before {
                background: ${utils.isNotNull(compositeStyle, 'sliderIndicator', 'normal', 'background') ? compositeStyle.sliderIndicator.normal.background : ''};
              }

              .slick-dots li button:before:hover {
                background: ${utils.isNotNull(compositeStyle, 'sliderIndicator', 'focussed', 'background') ? compositeStyle.sliderIndicator.focussed.background : ''};
              }

              .slick-dots li.slick-active button:before {
                background: ${utils.isNotNull(compositeStyle, 'sliderIndicator', 'selected', 'background') ? compositeStyle.sliderIndicator.selected.background : ''};
              }
            }
          `
      })
    })
  }}
`
